import useApi, { ApiOptions } from '../base/useApi';
import ProductionDTO from '@src/adapters/dto/production/ProductionDTO';

interface Params {}

interface Result {
  items: ProductionDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/production/list',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindProductionListLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindProductionListLazy;
